const en = {
	options: {
		pendingAppeal: 'Pending Appeal',
		waiting: 'Waiting',
		closed: 'Closed',
		searchID: 'Search merchant transaction ID',
		originID: 'Merchant Transaction ID',
	    omniOriginID: 'Merchant Transaction ID',
		website: 'Website',
		omniWebsite: 'Source',

		chargebackStatus: 'Chargeback Process',
		chargebackType: 'Type',
		all: 'All',
		retrieval: 'Retrieval',
		Chargeback1st: '1st Chargeback',
		Chargeback2nd: '2nd Chargeback',
		prearbitration: 'Pre-arbitration',
		reason: 'Chargeback Reason',
		allReason: 'All',
		notdescribed: 'Not as described',
		notReceived: 'Not received',
		fraud: 'Fraud',
		others: 'Others',
		download: 'Download',
		originalOrderIDWebsite: 'Merchant Transaction ID/website',
		omniOriginalOrderIDWebsite: 'Merchant Transaction ID/Store/Webiste',

		updateTime: 'Update time',
		deadline: 'Deadline',
		lessthandays: 'Less than 3 days',
		retrievalChargebackAmount: 'Retrieval/chargeback amount',
		operation: 'Operation',
		details: 'details',
		total: 'total',
		nocases: 'No retrieval/chargeback cases',
		noResult: 'no result',
		appealResults: 'appeal result',
		time: 'time',
		currentStatus: 'Chargeback Status',
		exportResults: 'Export results',
		allwebsite: 'All',
		omniAllwebsite: 'All',

		allstatus: 'All',
		allResult: 'All',
		chargebackTime: 'Creation Time',
		closeDate: 'Completed Date',
		status: 'status',
		startTime: 'Start time',
		endTime: 'End time',
		to: '-',
		storeGroup: 'Website/Group',
		omniStoreGroup: 'Store/Website/Group',
		groupName: 'Group',
		allGroup: 'All',
		operatorName: 'Operator',
		chargebackId: 'Chargeback ID',
		placeHolder: 'Please enter',
		chargebackIdo: 'ID',
		chargebackProtect: 'CB Protect'
	},
	chargeBackDetail: {
		pendingAppealList: 'Pending appeal list',
		retrievalDetail: 'Retrieval detail',
		chargebackDetail: 'Chargeback detail',
		retrievalDate: 'Retrieval Date',
		creationTime: 'Creation Time',
		retrievalAmount: 'Retrieval Amount',
		cardAssociation: 'Card Association',
		comment: 'Comment',
		file: 'File',
		reason: 'Reason',
		originalTransactionInformation: 'Original Transaction Information',
		websiteURL: 'Website URL',
		originalOrderID: 'Merchant Transaction ID',
		transactionID: 'Purchase Transaction ID',
		itemName: 'Logistics Information',
		amount: 'Amount',
		transactionTime: 'Transaction Time',
		shippingName: 'Shipping Name',
		clientEmail: 'Client Email',
		shippingPhoneNumber: 'Shipping Phone Number',

		highText: 'The success rate of the appeal is relatively high. We strongly recommend submitting it. Please follow the page instructions to complete your materials as thoroughly as possible.',
		midText: 'The success rate of the appeal is average. It is recommended to proceed with the appeal. Please follow the page instructions to complete your materials as thoroughly as possible.',
		lowText: 'The success rate of the appeal is relatively low. But you can still try to appeal. Please follow the page instructions to complete your materials as thoroughly as possible.',
		statement: 'The probability of a successful appeal is only an estimate of the potential outcome of a dispute/chargeback and does not guarantee any actual outcome. If you have any questions, please contact PingPong Checkout.',
		statusLabel: 'Success rate evaluation',

		order: 'order',
		reorder: 'reorder',
		retrievalProcess: 'Retrieval Process',
		chargebackProcess: 'Chargeback Process',
		bankNotify: 'Retrieval notification is received, amount is',
		bankNotify2nd: 'You have responded to the retrieval case',
		bankNotify4nd: 'You have responded to the chargeback case',
		bankNotify3rd: 'The information you provided can be optimized',
		waivedCase: 'You have waived the case',
		expiredCase: 'You did appeal the case before the deadline',
		bankNotify4th: '1st chargeback notification is received, amount is',
		bankNotifyretrieval: 'Chargeback notification is received, amount is',
		failedRetrievalCase: 'Retrieval case failed',

		cardHolderCancelled: 'The card holder cancelled the chargeback',
		chargeback2nd: '2nd chargeback notification is received',
		cardHolderConfirmed: 'The card holder has confirmed the pre-arbitration process. please respond it',
		confirmedArbitration: 'You have confirmed the pre-arbitration process.',
		arbitrationFailed: 'The decision of bank in the arbitration process: you lose the case',
		noneedArbitration: 'The case has no need to appeal due to refund',
		bankFeedbackSuccess: 'The response of bank in the arbitration process: you win the case',
		bankFeedbackFailed: 'The response of bank in the arbitration process: you lose the case',
		bankFeedbackPending: "You have entered the arbitration phase and are awaiting the bank's response.",

		waive: 'WAIVE',
		appealNow: 'APPEAL NOW',
		editMaterial: 'Modify the appeal information',
		respondRetrieval: 'Please respond the retrieval case',
		respondedRetrieval: 'You have responded to the retrieval case, please be patient and wait for the reply from the bank',
		issuesInfo: 'The information you provided has the following issues, please edit and resubmit.',
		waivedIssues: 'You have waived the case, please be patient and wait for the reply from the bank',
		expiredWaive: 'You did appeal the case before the deadline, please be patient and wait for the reply from the bank',

		chargebackCase1st: 'Please respond the 1st chargeback case',
		respond1stChargeback: 'You have responded to the 1st chargeback case, please be patient and wait for the reply from the bank',
		chargebackCase2nd: 'Please respond the 2nd chargeback case',
		respond2ndChargeback: 'You have responded to the 2nd chargeback case, please be patient and wait for the reply from the bank',
		resondCardHolderConfirmed: 'The card holder has confirmed the pre-arbitration process, please respond it.',
		lessThen3days: 'Less than three days',
		lessThen3daysFont: 'Please respond before',
		lessThen3daysAffect: 'or you will be considered to waive the chance.',
		lessThen3daysEnd: 'Any party who loses the case in the arbitration process will bear the arbitration fee.',
		comfirmedArbitration: 'You have confirmed the pre-arbitration process, please be patient and wait for the reply from the bank.',
		failedArbitration: 'The decision of bank in the arbitration process: the chargeback is valid and you lose the case',
		arbitrationSuccess: 'The decision of bank in the arbitration process: you win the case',
		cancelChargeback: 'The card holder cancelled the chargeback.',
		noneedAppeal: 'The case has no need to appeal due to refund',
		bankArbitrationSuccess: 'The response of bank in the arbitration process: you win the case',
		bankArbitrationPartialSuccess: 'The response of bank in the arbitration process: Partial Success',
		bankArbitrationFailed: 'The response of bank in the arbitration process: you lose the case',
		cancel: 'cancel',
		confirmedPreArbitration: 'Confirm',
		confirm: 'Confirm Pre-Arbitration',
		date: 'date',
		amountT: 'amount',
		noEmoji: 'No expression',
		chargebackProtect: 'Chargeback Protecting'
	},
	form: {
		retrievalAppeal: 'Retrieval Appeal',
		chargebackAppeal: 'Chargeback Appeal',
		uploadTips1st: 'Uploading requirements: please ensure that the ',
		uploadTips2nd: 'image picture and text are clearly visible',
		uploadTips3rd: 'the maximum size is no more than 5M, the format is limited to JPG, JPEG, PNG, BMP.',
		transactionInformation: 'Transaction information',
		itemName: 'Item name',
		receiverName: 'Receiver name',
		receiverPhone: 'Contact number',
		ShippingAddress: 'Shipping address',
		transactionInformationScreenshot: 'Screenshot of transaction information',
		addapic: 'Add a pic',
		shippingInformation: 'Shipping Information',
		shippingCompany: 'Shipping company',
		trackingNumber: 'Tracking number',
		thewaybillInformationScreenshot: 'Screenshot of waybill information',
		imagesOfMerchandise: 'Images of merchandise',
		DescriptionGoods: 'Images and description of merchandises',
		Imageofdelivered: 'Pictures of shipped merchandises',
		cardholdersSigned: 'Proof provided by the cardholder that the dispute has been withdrawn',
		customerContactInformation: 'Communication records between merchants and cardholders',
		ReasonsAppeal: 'Reasons and points for refuting the appeal from merchant',
		reasonsAndPoints: 'Reasons and points',
		feedbacksOfgoods: 'Feedback of merchandises',
		proofOfdelivery: 'Proof of delivery',
		cancellationAndRefundPolicy: 'Merchant’s Cancellation/Return & Refund Policy',
		transportationPolicy: 'Merchant Shipping Policy',
		submit: 'submit',
		save: 'save',

		submitTips: 'Please fill in at least one piece of information',
		submitSuccess: 'Submit success',
		saveSuccess: 'Save success',
		forgo: 'You have waived the case',
		netError: 'The network is crowded, please try again later!',
		waitAmins: 'Payment request has been initiated, please continue to pay on the original page or try it again 15 minutes later',
		select: 'Please Select',
		waiveAppeal: 'Are you sure you want to waive your appeal? After waive, you will not be able to appeal again. Please decide with caution.',
		chargebackConfirm: 'The chargeback will enter the arbitration stage. The arbitration fee 500 USD will be borne by the failed party, do you confirm to continue the appeal?',

		noticeSuccessConfirm: 'You have successfully confirmed the pre-arbitration',
		noticeFaildAppeal: 'You have waive your appeal',
		orderClipboard: 'Order number has been copied to the clipboard',
		noticeCopyFailed: 'Copy failed, please try again',
		noData: 'There is no retrieval/chargeback disputes in this list',
		noData2nd: 'There is no closed retrieval/chargeback disputes now',
		uploadFailed: 'File upload failed, please upload again',
		imageLimited: 'Upload up to {max} pictures',
		uoloadLimited: 'The size of uploaded files cannot exceed {max}M!'
	}
}

export default en
